import { useContext } from "react";
import ReactGA from "react-ga4";
import RequestQuoteFormContext from "./RequestQuoteFormContext";
import { ContactAPI } from "../../../api";

const Review = () => {
	const { details, contact, next, prev, setQuoteId } = useContext(
		RequestQuoteFormContext,
	);

	const handleSubmit = async (e) => {
		e.preventDefault();

		const payload = {
			from: details.from.label,
			to: details.to.label,
			quantity: details.quantity,
			weight: details.weight,
			length1: details.length1,
			width: details.width,
			height: details.height,
			description: details.description,
			full_name: contact.full_name,
			email_address: contact.email_address,
			phone_number: contact.phone_number, // wrapped in array
		};

		try {
			const response = await ContactAPI.submitQuoteForm(payload);
			const newId = response.data?.id;
			if (newId) {
				setQuoteId(newId);
			}
			ReactGA.event({
				category: "Quote Form",
				action: "quote_submitted",
			});
			next();
		} catch (err) {
			console.error(err);
			alert("Something went wrong.");
		}
	};

	return (
		<div className="w-full">
			<div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-8">
				{/* Contact */}
				<div>
					<p className="text-xs uppercase tracking-widest text-slate-400 font-medium mb-3">
						Contact
					</p>
					<div className="flex flex-col gap-2">
						<div className="flex flex-col">
							<span className="text-xs text-slate-400">Full name</span>
							<span className="text-sm text-slate-900 font-medium">
								{contact.full_name}
							</span>
						</div>
						<div className="flex flex-col">
							<span className="text-xs text-slate-400">Email</span>
							<span className="text-sm text-slate-900 font-medium">
								{contact.email_address}
							</span>
						</div>
						<div className="flex flex-col">
							<span className="text-xs text-slate-400">Phone</span>
							<span className="text-sm text-slate-900 font-medium">
								{contact.phone_number}
							</span>
						</div>
					</div>
				</div>

				{/* Parcel */}
				<div>
					<p className="text-xs uppercase tracking-widest text-slate-400 font-medium mb-3">
						Parcel
					</p>
					<div className="flex flex-col gap-2">
						<div className="flex flex-col">
							<span className="text-xs text-slate-400">From</span>
							<span className="text-sm text-slate-900 font-medium">
								{details.from.label}
							</span>
						</div>
						<div className="flex flex-col">
							<span className="text-xs text-slate-400">To</span>
							<span className="text-sm text-slate-900 font-medium">
								{details.to.label}
							</span>
						</div>
						<div className="grid grid-cols-2 gap-2">
							<div className="flex flex-col">
								<span className="text-xs text-slate-400">Quantity</span>
								<span className="text-sm text-slate-900 font-medium">
									{details.quantity}
								</span>
							</div>
							<div className="flex flex-col">
								<span className="text-xs text-slate-400">Weight</span>
								<span className="text-sm text-slate-900 font-medium">
									{details.weight} kg
								</span>
							</div>
						</div>
						<div className="flex flex-col">
							<span className="text-xs text-slate-400">Dimensions</span>
							<span className="text-sm text-slate-900 font-medium">
								{details.height} × {details.width} × {details.length1} cm
							</span>
						</div>
						<div className="flex flex-col">
							<span className="text-xs text-slate-400">Description</span>
							<span className="text-sm text-slate-900 font-medium">
								{details.description}
							</span>
						</div>
					</div>
				</div>
			</div>

			{/* Divider */}
			<div className="border-t border-slate-100 mb-6" />

			{/* Navigation */}
			<div className="grid grid-cols-2 gap-3">
				<button
					onClick={prev}
					className="py-2.5 border border-slate-200 ha:border-slate-400 text-slate-600 ha:text-slate-900 text-sm font-medium tracking-wide transition-all rounded-sm active:scale-[0.99]"
				>
					← Back
				</button>
				<button
					onClick={handleSubmit}
					className="py-2.5 bg-brand-500 ha:bg-brand-600 text-white text-sm font-medium tracking-wide transition-all rounded-sm active:scale-[0.99]"
				>
					Submit
				</button>
			</div>
		</div>
	);
};
export default Review;
